



















import { Component, Vue } from 'vue-property-decorator';
import IconInfo from '@/components/icons/IconInfo.vue';
import FulfillmentOptions from '@/components/common/FulfillmentOptions.vue';

@Component({
  components: {
    FulfillmentOptions,
    IconInfo,
  },
})
export default class MenuBar extends Vue {
}
